import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getFeatureUsage: build.query({
      query: () => ({ url: '/api/trial_awareness/feature_usages' }),
      extraOptions: {
        transformResponse: false
      }
    }),
  })
})

export const { useGetFeatureUsageQuery } = api
